export function injectCss(styleString: string) {
  const style = document.createElement('style');
  style.textContent = styleString;
  document.head.append(style);
}
